// NovaAI.styles.web.ts
import {Platform, StyleSheet} from 'react-native';
import Typography from '../../../shared/constants/Typography';
import {palette} from '@shared/theme/colorGroups/palette.colors';

export const createNovaAIWebStyles = (
  theme: any,
  width: number,
  height: number,
  isExpanded?: boolean,
  isDark?: boolean,
  // Extreme browser zoom (320x256 CSS px at 400%): the chat window fills the
  // viewport instead of being sized from it minus the nav header (which left
  // ~96 px — just the header strip).
  isZoomed?: boolean,
  // Extreme zoom only: the caret button collapses the window to its header bar
  // (anchored to the bottom) and restores it to full screen.
  isMinimized?: boolean,
) =>
  StyleSheet.create({
    // On the floating button while Hey Nova is listening: green, ringed in
    // white so it reads on the button's blue in either theme.
    wakeWordDot: {
      position: 'absolute' as any,
      top: Typography.padding.padding4,
      right: Typography.padding.padding4,
      width: 14,
      height: 14,
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth2,
      borderColor: palette.gray.white,
      backgroundColor: palette.semantic.mediumGreen,
    },
    floatingButton: {
      position: 'fixed' as any,
      bottom: isZoomed ? 16 : 80,
      right: isZoomed ? 16 : 36,
      // width: Typography.width.width72,
      // height: Typography.height.height72,
      // borderRadius: Typography.radius.radius36,
      // backgroundColor: theme.novaAIIconBGColor,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      zIndex: isZoomed ? 2147483000 : 9999,
      cursor: 'pointer' as any,
      // shadowColor: theme.dropdownShadowColor,
      // shadowOffset: {width: 0, height: Typography.height.height4},
      // shadowOpacity: 0.3,
      // shadowRadius: 8,
      // elevation: 10,
    },
    novaAIIcon: {
      width: Typography.width.width32,
      height: Typography.height.height32,
    },
    // Full-screen fixed overlay — transparent, does NOT block clicks outside chat window
    overlay: {
      position: 'fixed' as any,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'transparent',
      zIndex: isZoomed ? 2147483000 : 9998,
      pointerEvents: 'box-none' as any,
    },
    // Chat window wrapper — anchored bottom-right of the fixed overlay (= viewport).
    // When expanded: top is pinned below the nav header (80 px) so it never overlaps it.
    shadowWrapper: {
      position: Typography.position.absolute,
      ...(isZoomed
        ? isMinimized
          ? {bottom: 8, left: 8, right: 8, height: 72}
          : {top: 8, bottom: 8, left: 8, right: 8}
        : isExpanded
        ? {top: 80, bottom: 0, left: 0, right: 0}
        : {bottom: 80, right: 20, width: width, height: height}),
      shadowColor: theme.dropdownShadowColor,
    },
    modalView: {
      width: Typography.fullWidth,
      height: Typography.fullHeight,
      backgroundColor: theme.bGColor,
      borderRadius: Typography.radius.radius16,
      overflow: 'hidden',
      shadowColor: theme.dropdownShadowColor,
      shadowOffset: {width: 0, height: Typography.height.height4},
      shadowOpacity: 0.25,
      shadowRadius: 8,
      elevation: 8,
      borderWidth: isDark ? Typography.borderWidth.borderWidth1: 0.5,
      borderColor: theme.borderMainColor,
    },
  });
  